// Greek translations
export const el = {
    login: {
        title: "Είσοδος στο YMS",
        emailLabel: "Email",
        emailPlaceholder: "Το email σας",
        passwordLabel: "Κωδικός πρόσβασης",
        passwordPlaceholder: "Ο κωδικός πρόσβασής σας",
        submit: "Σύνδεση",
        forgotPassword: "Ξεχάσατε τον κωδικό σας;",
        selectLanguage: "Επιλέξτε γλώσσα",
        logoAlt: "Λογότυπο YARD",
        entersoftLogoAlt: "Λογότυπο Entersoft",
        requiredField: "Υποχρεωτικό πεδίο",
        needAccount: "Χρειάζεσαι λογαριασμό;",
        signUpHere: "Εγγραφείτε εδώ"
    },
    signUp: {
        title: "Εγγραφή στο YMS",
        fullName: "Ονοματεπώνυμο",
        fullNamePlaceholder: "Ονοματεπώνυμο",
        email: "Email",
        emailPlaceholder: "Email",
        phone: "Τηλέφωνο",
        phonePlaceholder: "Τηλέφωνο",
        company: "Εταιρεία",
        companyPlaceholder: "Α.Φ.Μ Εταιρείας",
        internalUser: "Εσωτερικός",
        requiredName: "Το πεδίο Ονοματεπώνυμο είναι υποχρεωτικό.",
        requiredEmail: "Το πεδίο Email είναι υποχρεωτικό.",
        invalidEmail: "Το Email δεν είναι σε σωστή μορφή.",
        requiredCompany: "Το πεδίο Εταιρεία είναι υποχρεωτικό για εξωτερικούς χρήστες."
    },
    profile: {
        title: "Προφίλ",
        description: "Οι προσωπικές σας πληροφορίες εμφανίζονται σε αυτό το σημείο.",
        logout: "Έξοδος",
        userImageAlt: "Εικόνα χρήστη",
        company: "Εταιρεία",
        companyName: "Entersoftone",
        companyLogoAlt: "Λογότυπο εταιρείας",
        aboutTitle: "Σχετικά με εσάς",
        appearance: "Εμφάνιση",
        darkTheme: "Σκούρο θέμα",
        lightTheme: "Φωτεινό θέμα",
        colorSelection: "Επιλογή Χρωμάτων",
        resetColor: "Επαναφορά χρώματος",
        themes: {
            title: "Θέματα",
            autumnSpice: "Autumn Spice",
            ocean: "Ocean",
            forest: "Forest",
            AberonYardTheme: "Aberon Yard",
            lavender: "Lavender",
            stopJiggle: "Σταμάτημα Κουνήματος"
        },
        applySklavenitisColors: "Εφαρμογή όλων των χρωμάτων Σκλαβενίτης",
        resetAll: "Επαναφορά Όλων",
        name: "Όνομα",
        email: "Email",
        role: "Ρόλος",
        customStylesSaved: "Οι προσαρμοσμένες ρυθμίσεις αποθηκεύτηκαν με επιτυχία",
        clickToCustomize: "Κάντε κλικ για προσαρμογή χρωμάτων"
    },
    warehouseModal: {
        title: "Επιλογή Κέντρων Διανομής",
        description: "Επέλεξε τα κέντρα διανομής που θέλεις να εξυπηρετήσεις για την αποστολή των προϊόντων σου.",
        cancel: "Ακύρωση",
        continue: "Συνέχεια"
    },
    colors: {
        '--color-main-background': 'Κύριο Χρώμα',
        '--color-secondary-background': 'Δευτερεύον Χρώμα',
        '--color-secondary-dark-background': 'Σκούρο Δευτερεύον Χρώμα',
        '--color-shadow-background': 'Σκιά',
        '--color-capacity-background': 'Χρώμα Χωρητικότητας',
        '--color-capacity-full-background': 'Χρώμα Πλήρους Χωρητικότητας'
    },
    noMatch: {
        title: 'Ωχ! Ο δρόμος δεν βγάζει πουθενά!',
        description: 'Συγγνώμη, αλλά η διεύθυνση που έβαλες δεν οδηγεί πουθενά σε αυτήν την ιστοσελίδα.',
        goBack: 'Πάμε πίσω στην αρχική'
    },
    profileMenu: {
        userMenu: "Μενού Χρήστη",
        profile: "Προφίλ",
        logout: "Έξοδος",
        status: "Κατάσταση",
        statusItems: {
            expected: "Αναμενόμενα",
            arrived: "Έφτασε",
            readyToLoad: "Ετοιμο για φόρτωση",
            loading: "Φόρτωση...",
            finished: "Ολοκληρώθηκε"
        },
        goodMorning: "Καλημέρα",
        goodAfternoon: "Καλό απόγευμα",
        goodEvening: "Καλησπέρα"
    },
    passwordReset: {
        title: "Επαναφέρετε τον κωδικό σας",
        emailLabel: "Email",
        emailPlaceholder: "Το email σας",
        successMessage: "Ένα email έχει αποσταλεί για την επαναφορά του κωδικού σας. Παρακαλούμε περιμένετε να επικοινωνήσει μαζί σας ο διαχειριστής μέσω email με οδηγίες για τα επόμενα βήματα.",
    },
    pagination: {
        previous: "Προηγούμενη",
        next: "Επόμενη",
        pageInfo: "Σελίδα {current} από {total}"
    },
    changePassword: {
        title: "Αλλαγή κωδικού πρόσβασης",
        subtitle: "Για την πρώτη σας σύνδεση στο Aberon YMS, παρακαλώ δημιουργήστε τον κωδικό πρόσβασης που θα χρησιμοποιείτε στο εξής.",
        newPasswordLabel: "Νέος κωδικός πρόσβασης",
        newPasswordPlaceholder: "Νέος κωδικός",
        confirmPasswordLabel: "Επιβεβαίωση κωδικού πρόσβασης",
        confirmPasswordPlaceholder: "Επιβεβαίωση κωδικού",
        passwordsMismatch: "Οι κωδικοί δεν ταιριάζουν",
        backButton: "Πίσω",
        successMessage: "Επιτυχία! Ο κωδικός πρόσβασής σας άλλαξε με επιτυχία.",
        apiError: "Ο νέος κωδικός πρόσβασης και ο κωδικός επιβεβαίωσης δεν ταιριάζουν.",
    },
    StatusDescr: {
        pending: "Σε εκκρεμότητα",
        change: "Αλλαγή",
        preliminarDetention: "Προγραμματισμένη κράτηση",
        canceled: "Ακυρώθηκε",
        arrived: "Έφτασε",
        expected: "Αναμενόμενα",
        accepted: "Αποδεκτό",
        readyToLoad: "Έτοιμο προς φόρτωση",
        loading: "Φόρτωση",
        finished: "Ολοκληρώθηκε",
        default: "Δεν οριστικοποιήθηκε"
    },
    StatusExample: {
        pending: 'Η κράτηση δημιουργήθηκε, περιμένει επιβεβαίωση.',
        change: 'Η κράτηση τροποποιήθηκε και περιμένει νέα επιβεβαίωση.',
        preliminarDetention: 'Προγραμματισμένη ή επαναλαμβανόμενη κράτηση.',
        canceled: 'Η κράτηση ακυρώθηκε.',
        accepted: 'Η κράτηση επιβεβαιώθηκε και είναι ενεργή.',
        arrived: 'Το όχημα έφτασε στην Αυλή της Αποθήκης.',
        loading: 'Το όχημα φορτώνεται αυτή τη στιγμή.',
        finished: 'Η διαδικασία ολοκληρώθηκε επιτυχώς.',
        yard_expected: 'Το όχημα αναμένεται να φτάσει στο yard σύμφωνα με την κράτηση.',
        yard_arrived: 'Το όχημα έχει φτάσει στο yard και καταγράφηκε η άφιξή του.',
        yard_readyToLoad: 'Το όχημα είναι έτοιμο και περιμένει να ξεκινήσει η φόρτωση.',
        yard_loading: 'Το όχημα βρίσκεται αυτή τη στιγμή στη διαδικασία φόρτωσης.',
        yard_finished: 'Η φόρτωση ολοκληρώθηκε και το όχημα έφυγε από το yard.'
    },
    bookingCalendar: {
        days: "Μέρες",
        week: "Εβδομαδιαίο",
        deleteTitle: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή την κράτηση;",
        deleteDescr: "Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.",
        acceptDelete: "Ναι, διαγραφή",
        noWarehouseTitle: "Δεν βρέθηκαν Κέντρας Διανομής",
        noWarehouseMessage: "Φαίνεται πως δεν έχετε ρυθμίσει κανένα Κέντρο Διανομής ακόμα. Επικοινωνήστε με τον διαχειριστή ή ρυθμίστε ένα για να ξεκινήσετε τις κρατήσεις.",
        goToCurrent: "Μετάβαση στη σημερινή ημερομηνία",
        full: "Πλήρες",
        free: "Ελεύθερο"
    },
    ModalBooking: {
        successTitleForBooking: "Η κράτησης αποθηκευτηκε με επιτυχια",
        successSubTitleForBooking: "με BookingId",
        successSubTitleDetailsForBooking: "Μπορείς να δεις ή να επεξεργαστείς την κράτηση από το ημερολόγιο.",
        codeForEntry: "Κωδικός Εισόδου",
        createNewBookingTitle: "Δημιουργία νέας κράτησης",
        createScheduledBookingTitle: "Δημιουργία Προγραμματισμένης κράτησης",
        editBookingTitle: "Επεξεργασία κράτησης",
        stepBasicInfo: "Βασική Συμπλήρωση",
        stepActions: "Ενέργειες",
        quantitiesTitleForm: "Ποσότητες",
        quantitiesPlaceholder: "Εισάγετε ποσότητα",
        bookingFrequencyTitleForm: "Συχνότητα κράτησης",
        bookingFrequencyPlaceholder: "Εισάγετε συχνότητα",
        selectOneSupplierWarning: "Παρακαλώ επιλέξτε έναν προμηθευτή πρώτα",
        posTitleForm: "PO's",
        posPlaceholder: "Επιλέξτε PO",
        supplierTitleForm: "Προμηθευτής",
        supplierPlaceholder: "Επιλέξτε Προμηθευτή",
        plPlaceholder: "Επιλέξτε 3PL",
        descrSupplierTitleForm: "Περιγραφή Προμηθευτή",
        autoFilledField: "Συμπληρώνεται αυτόματα",
        requiredFieldsCompleted: "υποχρεωτικά πεδία ολοκληρώθηκαν",
        allRequiredFieldsCompleted: "Όλα τα υποχρεωτικά πεδία συμπληρώθηκαν!",
        dateTimeTitleForm: "Ημερομηνία και ώρα",
        driverTitleForm: "Οδηγός",
        licenseNoTitleForm: "Πινακίδα",
        phoneTitleForm: "Τηλέφωνο επικοινωνίας",
        descrForBookingTitle: "Λεπτομέρειες Ενεργειών",
        actionsHeader: "Ενέργειες",
        newTaskLabel: "Νέα ενέργεια",
        taskLabel: "Ενέργεια",
        categoryTitleForm: "Κατηγορία ειδών",
        cargoTypeTitleForm: "Τύπος φορτίου",
        extraTaskTitleForm: "Επιπλέον ενέργειες",
        itemCountTitleForm: "Πλήθος κωδικών",
        palletCountTitleForm: "Παλέτες",
        addTaskButton: "Προσθήκη Ενέργειας",
        yardTaskType: 'Τύπος Ενέργειας',
        errorSavingBooking: "Παρουσιάστηκε σφάλμα κατά την αποθήκευση της κράτησης",
        successPreBooking: "Επιτυχής αποθήκευση προγραμματισμένης κράτησης!",
        minutes: "λεπτά",
        minutesCapitalized: "Λεπτά",
        itemsShort: "κ",
        palletsShort: "π",
        bookingSimple: "Κράτηση",
        sumPallets: "Συνολικός αριθμός παλετών",
        sumItems: "Συνολικός αριθμός κωδικών",
        categoryRequired: "Η κατηγορία ειδών είναι υποχρεωτική για όλες τις εργασίες",
        selectOnlyOneSupplier: "Παρακαλώ επιλέξτε μόνο έναν Προμηθευτή",
        durationWillBeCalculated : "Η διάρκεια θα υπολογιστεί αυτόματα με βάση των παλετών και το πλήθος των κωδικών που προσθέσατε",
    },
    yardView: {
        unknown: "Άγνωστο",
        driverDelay: "Καθυστέρηση οδηγού",
        titleArrival: 'Στοιχεία Άφιξης',
        semiTrailer: 'Ρυμουλκούμενο',
        loadDone: "Η Φόρτωση τελείωσε",
        cancelLoading: "Ακύρωση ανάθεσης",
        driverArrived: "Ο οδηγός έφτασε",
        licensePlate: "Πινακίδα",
        supplier: "Προμηθευτής",
        showLicense: "Εμφάνιση Πινακίδας",
        showSupplier: "Εμφάνιση Προμηθευτή",
        errorNoTaskForDraggedTruck: "Δεν βρέθηκε η αντίστοιχη ενέργεια για το μεταφερόμενο φορτηγό",
        lastSMSSent: "Τελευταίο SMS αποστάλθηκε",
        errorNoPhoneForSms: "Λείπει ο αριθμός τηλεφώνου. Δεν είναι δυνατή η αποστολή SMS.",
        occupied: "Κατειλημμένη",
        closed: "Κλειστή",
        confirmLoadDoneTitle: "Επιβεβαίωση Ολοκλήρωσης",
        confirmLoadDoneMessage: "Είστε σίγουρος ότι θέλετε να ολοκληρώσετε τη φόρτωση;"
    },
    bookingFrequency: {
        title: "Μοτίβο επανάληψης",
        daily: "Καθημερινά",
        weekly: "Εβδομαδιαία",
        monthly: "Μηνιαία",
        yearly: "Ετήσια",
        bookingTimeTitle: "Ώρα κράτησης",
        startTime: "Έναρξη",
        duration: "Διάρκεια",
        repetitionPeriodTitle: "Περίοδος Επανάληψης",
        repetitionStart: "Έναρξη",
        endsNever: "Ποτέ",
        endsAfter: "Τελειώνει μετά:",
        endsAfterTimes: "φορές",
        endsUntil: "Τελειώνει μέχρι:",
        recurrencePattern: "Μοτίβο Επανάληψης",
        recurrencePeriod: "Περίοδος Επανάληψης",
        never: "Ποτέ",
        endAfter: "Τελειώνει μετά:",
        times: "φορές",
        endBy: "Τελειώνει μέχρι:",
        am: 'π.μ.',
        pm: 'μ.μ.',
        time: 'Ώρα'
    },
    listPos: {
        poCode: "PO's",
        supplier: "Προμηθευτής",
        dateTime: "Ημερομηνία & Ώρα",
    },
    listSuppliers: {
        code: "Κωδικός",
        supplier: "Προμηθευτής",
        nameShort: "Συντομογραφία",
        vat: "Α.Φ.Μ",
        clickToFetch: 'Κάντε κλικ στο "Εικονίδιο φόρτωσης" για να φορτώσετε δεδομένα ή χρησιμοποιήστε την αναζήτηση για να βρείτε συγκεκριμένες εγγραφές'
    },
    list3pls: {
        code: "Κωδικός",
        description: "Περιγραφή",
        socialSecurityNo: "Α.Φ.Μ",
        clickToFetch: 'Κάντε κλικ στο "Εικονίδιο φόρτωσης" για να φορτώσετε δεδομένα ή χρησιμοποιήστε την αναζήτηση για να βρείτε συγκεκριμένες εγγραφές'
    },
    contextMenu: {
        newBooking: "Νέα Κράτηση",
        scheduledBooking: "Προγραμματισμένη Κράτηση",
        editable: "Επεξεργασία",
    },
    calendarEvent: {
        duration: "Χρόνος Κράτησης",
        ramp: "Ράμπα",
        plate: "Πινακίδα",
        driver: "Οδηγός",
        phone: "Τηλέφωνο",
        noActions: "Δεν επιτρέπεται καμία ενέργεια",
        noActionsAdded: "Δεν υπάρχουν ενέργειες.",
        withOutSupplier: "Χωρίς προμηθευτή",
        noEvents: "Δεν υπάρχουν κρατήσεις."
    },
    truckJourney: {
        loading: "Φόρτωση...",
        noZonesMessage: "Δεν έχουν καταχωρηθεί ζώνες για το συγκεκριμένο κέντρο διανομής",
        noArrivalsMessage: "Δεν υπάρχουν κρατήσεις για αφίξεις",
        noParkingMessage: "Δεν υπάρχουν κρατήσεις για πάρκινγκ",
        driverDelay: "Καθυστέρηση οδηγού",
        name: "Όνομα",
        unknown: "Άγνωστο",
        licensePlate: "Πινακίδα",
        resendSMS: "Εκ νέου αποστολή SMS",
        rampAssignment: "Ανάθεση ενεργειών σε ράμπα",
        selectWarehouse: "Επιλέξτε Κέντρο Διανομής",
        selectTaskBeforeDrag: "Παρακαλώ επιλέξτε μια ενέργεια πριν την μεταφορά σε ράμπα",
        allButton: "Όλες οι Ράμπες",
        allZones: "Όλες οι Ζώνες"
    },
    tablet: {
        entry: "Είσοδος",
        entryWithNoBooking: "Είσοδος χωρίς κράτηση",
        entryWithBooking: "Είσοδος με κράτηση",
        exit: "Έξοδος οχήματος",
        home: "Αρχική σελίδα",
        noTaskError: "Πρέπει να προσθέσετε τουλάχιστον μία εργασία πριν την αποθήκευση.",
        noDriverError: "Πρέπει να επιλέξετε έναν οδηγό πριν την αποθήκευση.",
        noTruckError: "Πρέπει να επιλέξετε ένα φορτηγό πριν την αποθήκευση.",
        qrNotActiveOrNotExist: "Ο κωδικός QR είτε δεν είναι ενεργός είτε δεν υπάρχει.",
        driver: "Ο οδηγός",
        driverBan: "έχει απαγόρευση εισόδου. Παρακαλώ επιλέξτε άλλον οδηγό.",
        driverBanWarning: "Ο οδηγός \"{{driverName}}\" έχει απαγόρευση εισόδου. Παρακαλώ επιλέξτε άλλον οδηγό.",
        cannotSaveWithBannedDriver: "Δεν μπορείτε να αποθηκεύσετε με οδηγό που έχει απαγόρευση εισόδου. Παρακαλώ επιλέξτε άλλον οδηγό.",
        noBookingSelected: "Δεν είναι δυνατή η αποθήκευση της κράτησης. Παρακαλώ επιλέξτε κράτηση.",
        noWarehouseTitle: "Δεν έχετε Κέντρο Διανομής",
        noWarehouseMessage: "Παρακαλώ επικοινωνήστε με τον διαχειριστή για να σας αναθέσει ένα Κέντρο Διανομής."
    },
    entryWithBooking: {
        title: "Είσοδος με κράτηση",
        subtitle: "Έχετε κωδικό εισόδου, γνωρίζετε το ΑΦΜ του 3PL/Προμηθευτή ή την Πινακίδα;",
        qrLabel: "Κωδικός QR",
        qrPlaceholder: "Εισαγωγή χειροκίνητα",
        scanQrButton: "Σάρωση QR κωδικού",
        supplierLabel: "3PL/Προμηθευτή",
        supplierPlaceholder: "Εισάγεται το Α.Φ.Μ 3PL/Προμηθευτή",
        availableBookings: "Διαθέσιμα Bookings",
        bookingId: "Booking ID",
        warehouse: "Αποθήκη",
        supplier: "Προμηθευτής",
        scanButton: "Ανίχνευση",
        stampTitleForm: "Σφραγίδα",
        commentTitleForm: "Σχόλιο",
        successTitle: "Επιτυχής παραχώρηση εισόδου",
        nextEntry: "Επόμενη είσοδος",
        supplierTab: "Προμηθευτής",
        ownedCooperatingTab: "Ιδιόκτητο/Συνεργαζόμενο",
        stampSection: "Σφραγίδα",
        stampNo: "Όχι",
        stampElectronic: "Ηλεκτρονική",
        stampPlastic: "Πλαστική",
        plasticStampPlaceholder: "Καταγράψτε τη σφραγίδα",
        genderSection: "Κενός",
        genderNo: "Όχι",
        genderYes: "Ναι"
    },
    newWithBooking: {
        loadingTasks: "Φορτωση ενεργειών",
        supplierVatTitleForm: "Α.Φ.Μ Προμηθευτή",
        placeholderVatTitleForm: "Εισάγεται το Α.Φ.Μ",
        availableVats: "Διαθέσιμα Α.Φ.Μ",
    },
    exitBooking: {
        warningWithBookingAndVat: "Δεν βρέθηκε πινακίδα που να ταιριάζει με καποιο από τα Bookings. Παρακαλώ ελέγξτε την πινακίδα και προσπαθήστε ξανά.",
        pendingBookingWarning: "Υπάρχουν εκκρεμείς κρατήσεις που πρέπει να ολοκληρωθούν."
    },
    photoUpload: {
        addPhotos: "Προσθήκη φωτογραφιών",
        addMorePhotos: "Προσθήκη επιπλέον φωτογραφιών",
        openCamera: "Άνοιγμα κάμερας",
        chooseFromLibrary: "Επιλογή από βιβλιοθήκη"
    },
    common: {
        loading: "Φόρτωση...",
        error: "Σφάλμα",
        next: "Επόμενο",
        success: "Επιτυχία",
        warning: 'Προειδοποίηση',
        backButton: "Πίσω",
        no: "Όχι",
        resetButton: "Επαναφορά",
        changeButton: "Αλλαγή",
        saveButton: "Αποθήκευση",
        prevButton: "Προηγούμενο",
        select: "Επιλογή",
        choose: "Επιλέξτε",
        registration: "Υποβολή",
        noData: "Δεν βρέθηκαν δεδομένα",
        add: "Προσθέστε",
        accept: "Αποδοχή",
        acceptedSuccess: "Επιτυχής αποδοχή!",
        cancelledSuccess: "Επιτυχής ακύρωση!",
        delete: "Διαγραφή",
        cancel: "Άκυρο",
        confirm: "Επιβεβαίωση",
        search: "Αναζήτηση",
        submit: "Εγγραφή",
        cancelled: "Ακύρωση",
        apply: "Εφαρμογή",
        deselectAll: "Αποεπιλογή όλων",
        totalRows: "Σύνολο γραμμών:",
        rowsPerPage: "Γραμμές ανά σελίδα:",
        displayedRows: "{{from}}–{{to}} από {{count}}",
        moreThan: "περισσότερες από {{to}}",
        rowSelected: "{{count}} γραμμή επιλέχθηκε",
        rowsSelected: "{{count}} γραμμές επιλέχθηκαν",
        requiredField: "Απαιτείται τιμή για το πεδίο",
        clear: "Καθαρισμός",
        allCategories: "Όλες οι κατηγορίες",
        selectOne: "Επιλέξτε",
        changesSaved: "Οι αλλαγές αποθηκεύτηκαν με επιτυχία!",
    },
    toolkit: {
        filterDesigner: "Queries",
        fieldChooser: "Επιλογέας Πεδίων",
        exportExcel: "Εξαγωγή σε Excel",
        table: 'Πίνακας',
        grid: 'Πλέγμα',
        dashboard: 'Πίνακας Ελέγχου',
        filterExpression: "Queries",
        fields: 'Πεδία'
    }
};
